export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (typeof window !== "undefined" && window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -76, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}

export const WHATSAPP_URL = "https://wa.me/393290030516";
export const PHONE = "+39 329 00 30 516";
export const EMAIL = "info@albaselection.it";
export const INSTAGRAM_URL = "https://www.instagram.com/alba.selection/";
export const INSTAGRAM_HANDLE = "@alba.selection";
export const LOGO_LIGHT = "https://customer-assets-jt897jd0.emergentagent.net/job_proprietari-salento/artifacts/a1bqu1od_logo%20bianco%20sfondo%20trasparente.png";
export const LOGO_DARK = "https://customer-assets-jt897jd0.emergentagent.net/job_proprietari-salento/artifacts/tzf27zyu_logo%20nero%20sfondo%20trasparente.png";
